import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import { Suspense, useEffect } from "react";
import i18n from "./i18n";
import ErrorBoundary from "./components/ErrorBoundary";

function PageLoader() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0d1f3c 0%, #152a52 60%, #111e3a 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '32px', marginBottom: '16px' }}>🏡</div>
        <div style={{ color: '#c9a227', fontSize: '14px', fontWeight: 700, letterSpacing: '0.1em' }}>홈 &amp; 그레이브</div>
      </div>
    </div>
  );
}

/**
 * 모바일 기기 감지 후 /mobile 로 이동
 * App 최상위 레벨에서 동작 — 어떤 라우팅 로직과도 완전 독립
 */
function MobileRedirector() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const path = location.pathname;

    // 이미 모바일 or 관리자 or 리포트 경로면 리다이렉트 안 함
    if (
      path.startsWith('/mobile') ||
      path.startsWith('/admin') ||
      path.startsWith('/work-report') ||
      path.startsWith('/quote') ||
      path.startsWith('/r/')
    ) return;

    // ?view=desktop 강제 PC 모드
    if (location.search.includes('view=desktop')) return;

    // 토큰 있으면 리포트 인증 흐름 유지
    const hash = window.location.hash;
    const sp = new URLSearchParams(location.search);
    if (hash.startsWith('#token=') || sp.has('token') || hash === '#auth') return;

    // 모바일 감지: UserAgent 우선
    const ua = navigator.userAgent || '';
    const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua);
    const isNarrow = window.innerWidth <= 767;

    if (isMobileUA || isNarrow) {
      navigate('/mobile', { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ErrorBoundary>
          <Suspense fallback={<PageLoader />}>
            <MobileRedirector />
            <AppRoutes />
          </Suspense>
        </ErrorBoundary>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
